export function Tutors() {
  return (
    <div className="space-y-4">
      <p className="text-gray-600">Tutors settings coming soon...</p>
    </div>
  );
}